var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sliderButton",class:[
    `sliderButton--${_vm.buttonType}`,
    `sliderButton--${_vm.position}`,
    { 'sliderButton--disabled': _vm.disabled },
    { 'sliderButton--rightControls': _vm.rightControls },
  ],on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }